import { computed } from 'vue'

import { message, showMutationError, useConfirm } from '@/shared/lib'

import { useDisconnectTelegramAccount } from '@/apps/adok/entities/telegram-account'

import { useOpenTelegramBot } from './useOpenTelegramBot'

export function useTelegramAccountActions() {
  const { confirm } = useConfirm()

  const { openBot, isOpening } = useOpenTelegramBot()
  const { mutate: disconnect, isPending: isDisconnecting } =
    useDisconnectTelegramAccount()

  const isBusy = computed(() => isOpening.value || isDisconnecting.value)

  async function disconnectBot() {
    const ok = await confirm(
      'Disconnect Telegram? Notifications will stop arriving there.'
    )
    if (!ok) return

    disconnect(undefined, {
      onSuccess: () => message.success('Telegram has been disconnected.'),
      onError: (error) =>
        showMutationError(error, 'Could not disconnect Telegram.')
    })
  }

  return { isBusy, connect: openBot, disconnectBot }
}
